import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';

import { Loader } from '@hbf/dsl';

import { getIsLoading } from '../selectors';

const useStyles = makeStyles()(() => ({
  progress: {
    position: 'fixed',
    top: '50%',
  },
}));

const SearchResultsLoader: React.FC = () => {
  const { classes } = useStyles();
  const loading = useSelector(getIsLoading);

  const [show, setShow] = React.useState(false);
  const timeoutIdRef = React.useRef<number>(0);

  React.useEffect(() => {
    if (!loading) {
      setShow(false);
      clearTimeout(timeoutIdRef.current);

      return;
    }

    timeoutIdRef.current = window.setTimeout(() => setShow(true), 200);
  }, [loading]);

  return show ? (
    <Loader
      progressProps={{ className: classes.progress, disableShrink: true }}
    />
  ) : null;
};

export { SearchResultsLoader };
